import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Icon, IconTileView } from '../../../base/icons';
import { isLocalParticipantModerator } from '../../../base/participants/functions';
import { Switch } from '../../../base/react';
import { isVisitorsModeEnabled } from '../../../visitors/functions';
import { amIInBackstage, getAudienceLayout, updateAudienceLayout } from '../../../webinar';
import { useModerationStyles } from './styles';
/**
 * Moderator controls for the visitor-facing webinar participant layout.
 *
 * @returns {JSX.Element | null}
 */
const AudienceLayoutSection = () => {
    const { t } = useTranslation();
    const { classes, cx } = useModerationStyles();
    const dispatch = useDispatch();
    const isModerator = useSelector(isLocalParticipantModerator);
    const inBackstage = useSelector(amIInBackstage);
    const visitorsModeEnabled = useSelector(isVisitorsModeEnabled);
    const { showOnlyPanelists, stageOnlyMode } = useSelector(getAudienceLayout);
    const onShowOnlyPanelists = useCallback((value) => dispatch(updateAudienceLayout({ showOnlyPanelists: value })), [dispatch]);
    const onStageOnlyMode = useCallback((value) => dispatch(updateAudienceLayout({ stageOnlyMode: value })), [dispatch]);
    if (!isModerator || inBackstage || !visitorsModeEnabled) {
        return null;
    }
    return (React.createElement("div", { className: classes.card },
        React.createElement("div", { className: classes.cardHeader },
            React.createElement("div", { className: classes.cardIcon },
                React.createElement(Icon, { size: 16, src: IconTileView })),
            React.createElement("span", { className: classes.cardTitle }, t('webinar.audienceLayoutTitle'))),
        React.createElement("p", { className: classes.cardDescription }, t('webinar.audienceLayoutDescription')),
        React.createElement("div", { className: cx(classes.row, classes.rowDivided) },
            React.createElement("div", { className: classes.rowText },
                React.createElement("label", { className: classes.rowLabel, htmlFor: 'webinar-show-panelists-switch' }, t('webinar.showOnlyPanelists')),
                React.createElement("span", { className: classes.rowHint }, t('webinar.showOnlyPanelistsHint'))),
            React.createElement(Switch, { id: 'webinar-show-panelists-switch', onValueChange: onShowOnlyPanelists, value: showOnlyPanelists })),
        React.createElement("div", { className: cx(classes.row, classes.rowDivided) },
            React.createElement("div", { className: classes.rowText },
                React.createElement("label", { className: classes.rowLabel, htmlFor: 'webinar-stage-only-switch' }, t('webinar.stageOnlyMode')),
                React.createElement("span", { className: classes.rowHint }, t('webinar.stageOnlyModeHint'))),
            React.createElement(Switch, { id: 'webinar-stage-only-switch', onValueChange: onStageOnlyMode, value: stageOnlyMode }))));
};
export default AudienceLayoutSection;
